import React from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";



am4core.useTheme(am4themes_material);

export default function Chart(initialState, type) {
    const ref = React.useRef(null);
    const [ c, updateChart ] = React.useState(null);

    React.useEffect(() => {
        if (!ref || !ref.current) {
            return
        }
        const chart = am4core.createFromConfig(initialState, ref.current, type);
        updateChart(chart)
        return () => chart.dispose();
    }, [ref]);

    return [ref, c, updateChart];
}
